<template>
    <div>
        <div>
            <div class="grid gap-1">

                <div class="flex flex-col lg:flex-row lg:justify-between lg:items-end">
                    <div>
                        <h3>{{$t('Grazie')}} {{user.nome}}</h3>
                        <p>
                            {{$t('La tua registrazione è quasi completa!')}} <br>
                            {{$t('sent_email_confirm')}} <b>{{user.email}}</b>. <br>
                            <span v-html="$t('check_email')"></span>
                            <b class="pl-[4px]"><a @click="sendMail()">{{$t('questo link')}}</a></b>
                            <br> {{$t('new_email_confirm')}} <br><br>
                            {{$t('Grazie per unirti a noi!')}}
                        </p>
                    </div>
                    <div class="flex md:justify-end gap-3">
                        <v-btn class="mt-3" color="primary" dark :loading="btn_loading" @click="skipConfirm()">{{$t('Accedi al tuo profilo')}}</v-btn>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "CreateConfirm",
    data() {
        return {
            btn_loading: false,
            sent: false,
        };
    },
    computed: {
        user() {
            let _user = this.$store.getters["user/user"];
            return _user;
        },
    },
    methods: {
        async sendMail(){
            this.btn_loading = true
            if(!this.user.email){
                this.btn_loading = false
                return
            }

            let body = {
                type: "confirmemail",
                email: this.user.email
            }
            await this.$store.dispatch("sendMail",body)
            this.btn_loading = false
            this.sent = true
        },
        async skipConfirm(){
            this.btn_loading = true
            let body = {
                registrazioneCompletata: 0
            }
            let response = await this.$store.dispatch('user/editUser',body)
            if(response.response.error){
                this.btn_loading = false
                return
            }
            window.location.reload()

        }
    },
};
</script>

<style lang="scss" scoped>
/*  */
</style>
